import React from "react";
import { useState, useEffect } from "react";
import { toast } from "sonner";
import { ImCancelCircle } from "react-icons/im";
import { useGlobalContext } from "../../context";
import UserSideNav from "../components/UserSideNav";
import api from "../../api";
import { GiHamburgerMenu } from "react-icons/gi";
import { BiLogOut } from "react-icons/bi";
import userDashLinks from "./userDashLinks";
import { BiSolidWallet } from "react-icons/bi";
import { BsChevronDown } from "react-icons/bs";
import spinner from "../../images/SpinnerTrans.svg";
import { useNavigate } from "react-router-dom";

const plans = [
  {
    name: "Standard Trading",
    label: "Standard",
    rate: "1.26",
    range: "$1,000 – $4,999",
    desc: "Entry-level automated trading with consistent daily returns.",
  },
  {
    name: "Silver Trading",
    label: "Silver",
    rate: "1.98",
    range: "$5,000 – $14,999",
    desc: "Mid-tier plan with elevated returns for growing portfolios.",
  },
  {
    name: "Gold Trading",
    label: "Gold",
    rate: "2.88",
    range: "$15,000 – $24,999",
    desc: "High-yield plan for serious investors seeking strong returns.",
    featured: true,
  },
  {
    name: "Platinum Trading",
    label: "Platinum",
    rate: "4.14",
    range: "$25,000 – $100,000",
    desc: "Premium tier with maximum daily yield for large capital.",
  },
];

const Usertrade = () => {
  const navigate = useNavigate();
  const { allUserMongoData } = useGlobalContext();

  //user side nav----------------
  const [navActive, updateNavActive] = useState(null);

  useEffect(() => {
    if (navActive) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [navActive]);

  const clearSess = async () => {
    try {
      await api.post("/api/logout");
    } catch (e) {}
    window.sessionStorage.clear();
  };

  const hideNav = () => {
    updateNavActive(false);
  };

  //profit calculator-------------
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("Select a Plan");
  const [expReturn, updateExpReturn] = useState(null);
  const [planAmount, updatePlanAmount] = useState({
    amount: "",
  });

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
  };

  const doProfitCalc = () => {
    const Amount = planAmount.amount;

    if (selectedOption === "Select a Plan") {
      toast.error("Please select plan");
      return updatePlanAmount({ amount: "" });
    }

    if (!Amount) {
      toast.error("Please input amount");
      updateExpReturn();
      return updatePlanAmount({ amount: "" });
    }

    if (selectedOption === "Standard Trading") {
      if (Amount < 1000 || Amount > 4999) {
        toast.error("Please input a valid figure between 1000 and 4999");
        updatePlanAmount({ amount: "" });
        return updateExpReturn();
      } else {
        const StCalc = (Amount * (1.26 / 100) * 30).toFixed(2);
        const UpdatedStReturn = (Number(Amount) + Number(StCalc)).toFixed(2);
        return updateExpReturn(Number(UpdatedStReturn).toLocaleString(`us-EN`));
      }
    }

    if (selectedOption === "Silver Trading") {
      if (Amount < 5000 || Amount > 14999) {
        toast.error("Please input a valid figure between 5000 and 14999");
        updateExpReturn();
        return updatePlanAmount({ amount: "" });
      } else {
        const StCalc = (Amount * (1.98 / 100) * 30).toFixed(2);
        const UpdatedStReturn = (Number(Amount) + Number(StCalc)).toFixed(2);
        return updateExpReturn(Number(UpdatedStReturn).toLocaleString(`us-EN`));
      }
    }

    if (selectedOption === "Gold Trading") {
      if (Amount < 15000 || Amount > 24999) {
        toast.error("Please input a valid figure between 15000 and 24999");
        updateExpReturn();
        return updatePlanAmount({ amount: "" });
      } else {
        const StCalc = (Amount * (2.88 / 100) * 30).toFixed(2);
        const UpdatedStReturn = (Number(Amount) + Number(StCalc)).toFixed(2);
        return updateExpReturn(Number(UpdatedStReturn).toLocaleString(`us-EN`));
      }
    }

    if (selectedOption === "Platinum Trading") {
      if (Amount < 25000 || Amount > 100000) {
        toast.error("Please input a valid figure between 25000 and 100000");
        updateExpReturn();
        return updatePlanAmount({ amount: "" });
      } else {
        const StCalc = (Amount * (4.14 / 100) * 30).toFixed(2);
        const UpdatedStReturn = (Number(Amount) + Number(StCalc)).toFixed(2);
        return updateExpReturn(Number(UpdatedStReturn).toLocaleString(`us-EN`));
      }
    }
  };

  //select and start trading plan ------------------
  const [planType, updatePlanType] = useState("");
  const [ActiveAmountCard, updateActiveAmountCard] = useState(null);
  const [amountCardForm, updateAmountCardForm] = useState({
    amount: "",
    plantype: "",
  });
  const [isLoadingBtn, updateisLoadingBtn] = useState(null);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const SubmitTradeForm = async () => {
    updateisLoadingBtn(true);
    setIsButtonDisabled(true);

    try {
      const tradePost = await api.post("/api/user/trade", {
        ...amountCardForm,
      });
      const tradeData = tradePost.data;

      if (tradeData.errMsg) {
        toast.error(tradeData.errMsg);
        updateAmountCardForm({ ...amountCardForm, amount: "" });
        updateisLoadingBtn(false);
        setIsButtonDisabled(false);
        setTimeout(() => {
          navigate("/user/deposit");
        }, 7000);
      } else {
        toast.success(tradeData.successMsg);
        updateAmountCardForm({
          amount: "",
        });
        updateActiveAmountCard(false);
        updateisLoadingBtn(false);
        setIsButtonDisabled(false);
      }
    } catch (error) {
      console.log(error);
      updateisLoadingBtn(false);
      setIsButtonDisabled(false);
    }
  };

  const validatePlanForm = () => {
    const Amount = amountCardForm.amount;

    if (!Amount) {
      toast.error("Please input amount");
      return updateAmountCardForm({ amount: "" });
    }

    if (planType === "Standard Trading") {
      if (Amount < 1000 || Amount > 4999) {
        toast.error("Please input a valid figure between 1000 and 4999");
        return updateAmountCardForm({ amount: "" });
      } else {
        SubmitTradeForm();
      }
    }

    if (planType === "Silver Trading") {
      if (Amount < 5000 || Amount > 14999) {
        toast.error("Please input a valid figure between 5000 and 14999");
        return updateAmountCardForm({ amount: "" });
      } else {
        SubmitTradeForm();
      }
    }

    if (planType === "Gold Trading") {
      if (Amount < 15000 || Amount > 24999) {
        toast.error("Please input a valid figure between 15000 and 24999");
        return updateAmountCardForm({ amount: "" });
      } else {
        SubmitTradeForm();
      }
    }

    if (planType === "Platinum Trading") {
      if (Amount < 25000 || Amount > 100000) {
        toast.error("Please input a valid figure between 25000 and 100000");
        return updateAmountCardForm({ amount: "" });
      } else {
        SubmitTradeForm();
      }
    }
  };

  return (
    <div className="absolute overflow-hidden w-full min-h-full text-white bg-black">
      {/* Amount entry modal */}
      {ActiveAmountCard && (
        <div className="absolute w-full min-h-[100%] top-0 left-0 pt-[5rem] flex justify-center items-start bg-[#111111c9] z-50">
          <div className="relative w-[90%] flex flex-col justify-start items-start space-y-6 bg-[#0e1118] p-6 border border-[#1f2535] rounded-xl sm:w-[360px] ssm:w-[80%]">
            <div className="w-full flex justify-between items-center">
              <div>
                <p className="text-[11px] text-[#A9ABAD] uppercase tracking-widest">
                  Starting Plan
                </p>
                <h4 className="text-[16px] font-[600] text-white mt-1">
                  {planType}
                </h4>
              </div>
              <button
                onClick={() => {
                  updateActiveAmountCard(false);
                  updateAmountCardForm({ amount: "" });
                }}
              >
                <ImCancelCircle className="cursor-pointer text-[20px] text-[#A9ABAD] transition-all ease-in duration-300 hover:scale-[1.1]" />
              </button>
            </div>

            <div className="w-full h-[1px] bg-[#1f2535]" />

            <div className="w-full flex flex-col space-y-2">
              <label className="text-[12px] text-[#A9ABAD] uppercase tracking-widest">
                Investment Amount
              </label>
              <div className="w-full flex items-center space-x-2 border-b border-[#3b424c] focus-within:border-b-[#A9ABAD] pb-2 transition-colors">
                <span className="text-[18px] text-[#A9ABAD]">$</span>
                <input
                  value={amountCardForm.amount}
                  onBlur={() =>
                    updateAmountCardForm({
                      ...amountCardForm,
                      plantype: planType,
                    })
                  }
                  onChange={(e) => {
                    updateAmountCardForm({
                      ...amountCardForm,
                      amount: e.target.value,
                    });
                  }}
                  type="number"
                  name="amount"
                  className="appearance-none no-number-arrows custom-holder w-full h-[48px] bg-inherit text-white text-[20px] focus:outline-none"
                  placeholder="0.00"
                />
              </div>
            </div>

            <button
              disabled={isButtonDisabled}
              onClick={() => {
                validatePlanForm();
              }}
              className="w-full min-h-[44px] flex justify-center items-center text-[14px] font-[500] bg-userDashPurple rounded-lg transition-all ease-in duration-200 hover:bg-[#3d34b5] disabled:opacity-60"
            >
              {isLoadingBtn ? (
                <img
                  src={spinner}
                  className="w-[26px] h-[26px]"
                  alt="loading"
                />
              ) : (
                "Confirm & Trade"
              )}
            </button>
          </div>
        </div>
      )}

      <UserSideNav
        hideNav={hideNav}
        logout="/signin"
        logoutBtn={clearSess}
        translateAction={
          navActive ? `translate-x-[0px]` : `translate-x-[-500px]`
        }
        clearSess={clearSess}
        backgroundColor="bg-black"
        arrowCoLor="text-white"
        iconBorderColor="border-white"
        iconBgColor="bg-inherit"
        textColor="text-white"
        links={userDashLinks}
        logouticon={
          <BiLogOut className="cursor-pointer text-[20px] text-white transition-all ease-in duration-300 hover:scale-[1.1] " />
        }
      />

      {navActive && (
        <div
          className="fixed inset-0 bg-black/60 z-40 xl:hidden"
          onClick={hideNav}
        />
      )}

      <div className="relative w-full h-full p-4 overflow-hidden mb-[100px] xl:pl-[304px] xl:pr-6">
        {/* top nav */}
        <nav className="relative w-full min-h-[100px] flex justify-center items-start">
          <div className="relative w-full min-h-[50px] flex justify-between items-center xl:justify-end">
            <button
              onClick={() => updateNavActive(true)}
              className="relative xl:hidden"
            >
              <GiHamburgerMenu className="text-[20px] text-[#A9ABAD]" />
            </button>

            <div className="relative flex space-x-2">
              <div className="relative flex justify-center items-center space-x-2 min-h-[38px] py-2 px-4 bg-[#181C26] border border-[#1f2535] rounded-lg transition-all ease-in duration-200 hover:border-[#473ECD]">
                <BiSolidWallet className="text-[14px] text-[#A9ABAD]" />
                <p className="text-[12px] text-[#A9ABAD]">
                  $
                  {allUserMongoData && allUserMongoData.balance
                    ? allUserMongoData.balance.toLocaleString()
                    : "0"}
                </p>
              </div>
            </div>
          </div>
        </nav>

        {/* page header */}
        <div className="relative w-full flex flex-col justify-start items-start space-y-1 pt-4 pb-8">
          <h3 className="text-[20px] font-[600] text-white">Trading Plans</h3>
          <p className="text-[#A9ABAD] text-[14px]">
            Select a 30-day automated trading plan within your capital range.
          </p>
        </div>

        {/* plan cards */}
        <div className="relative w-full grid grid-cols-1 gap-4 ssm:grid-cols-2 xl:grid-cols-4">
          {plans.map((plan) => (
            <div
              key={plan.name}
              className={`relative bg-[#181C26] rounded-xl p-5 flex flex-col justify-between min-h-[230px] border ${
                plan.featured ? "border-userDashPurple" : "border-[#1f2535]"
              }`}
            >
              {plan.featured && (
                <span className="absolute top-[-1px] right-4 text-[10px] font-[600] uppercase tracking-widest bg-userDashPurple text-white px-3 py-[3px] rounded-b-md">
                  Popular
                </span>
              )}

              <div className="flex flex-col space-y-3">
                <p className="text-[11px] text-[#A9ABAD] uppercase tracking-widest font-[500]">
                  {plan.label}
                </p>

                <div className="flex items-end space-x-1">
                  <span className="text-[30px] font-[700] text-white leading-none">
                    {plan.rate}%
                  </span>
                  <span className="text-[13px] text-[#A9ABAD] pb-[3px]">
                    / day
                  </span>
                </div>

                <p className="text-[12px] text-[#868e98] leading-relaxed">
                  {plan.desc}
                </p>

                <div className="flex items-center space-x-2 pt-1">
                  <span className="text-[11px] text-[#A9ABAD] bg-[#0d1017] px-2 py-1 rounded-full">
                    30 days
                  </span>
                  <span className="text-[12px] text-[#cacbcb] font-[500]">
                    {plan.range}
                  </span>
                </div>
              </div>

              <button
                onClick={() => {
                  updatePlanType(plan.name);
                  updateActiveAmountCard(true);
                  window.scrollTo(0, 0);
                }}
                className={`mt-5 w-full min-h-[40px] text-[13px] font-[500] rounded-lg transition-all ease-in duration-200 ${
                  plan.featured
                    ? "bg-userDashPurple text-white hover:bg-[#3d34b5]"
                    : "bg-inherit border border-[#2e3340] text-[#A9ABAD] hover:border-[#473ECD] hover:text-white"
                }`}
              >
                Get Started
              </button>
            </div>
          ))}
        </div>

        {/* profit calculator */}
        <div className="relative w-full flex flex-col justify-start items-start space-y-1 pt-[3.5rem] pb-4">
          <h3 className="text-[20px] font-[600] text-white">
            Profit Calculator
          </h3>
          <p className="text-[#A9ABAD] text-[14px]">
            Estimate your returns before committing to a plan.
          </p>
        </div>

        <div className="w-full bg-[#181C26] border border-[#1f2535] rounded-xl p-6 ssm:w-[90%] sm:w-[420px]">
          {/* plan selector */}
          <div className="w-full flex flex-col space-y-2 pb-5">
            <label className="text-[11px] text-[#A9ABAD] uppercase tracking-widest">
              Plan
            </label>
            <div className="relative">
              <button
                type="button"
                onClick={toggleDropdown}
                className="w-full flex justify-between items-center bg-[#0d1017] border border-[#1f2535] rounded-lg px-4 py-3 text-[13px] text-white"
              >
                <span>{selectedOption}</span>
                <BsChevronDown
                  className={`text-[#A9ABAD] text-[13px] transition-transform duration-200 ${
                    isOpen ? "rotate-180" : ""
                  }`}
                />
              </button>

              {isOpen && (
                <ul className="absolute top-[calc(100%+4px)] left-0 w-full z-50 bg-[#0d1017] border border-[#1f2535] rounded-lg overflow-hidden">
                  {[
                    "Standard Trading",
                    "Silver Trading",
                    "Gold Trading",
                    "Platinum Trading",
                  ].map((opt) => (
                    <li
                      key={opt}
                      onClick={() => {
                        handleOptionClick(opt);
                        updatePlanAmount({ amount: "" });
                        updateExpReturn();
                      }}
                      className="px-4 py-3 text-[13px] text-[#A9ABAD] hover:bg-[#181C26] hover:text-white cursor-pointer transition-colors"
                    >
                      {opt}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>

          <div className="w-full h-[1px] bg-[#1f2535] mb-5" />

          {/* amount input */}
          <div className="w-full flex flex-col space-y-2 pb-5">
            <label className="text-[11px] text-[#A9ABAD] uppercase tracking-widest">
              Investment Amount
            </label>
            <div className="w-full flex items-center bg-[#0d1017] border border-[#1f2535] rounded-lg px-4 focus-within:border-[#473ECD] transition-colors">
              <span className="text-[#A9ABAD] text-[14px] pr-2">$</span>
              <input
                value={planAmount.amount}
                onFocus={() => setIsOpen(false)}
                onChange={(e) => {
                  updatePlanAmount({ amount: e.target.value });
                }}
                type="number"
                name="amount"
                className="appearance-none no-number-arrows custom-holder w-full h-[48px] bg-inherit text-white text-[16px] focus:outline-none"
                placeholder="Enter amount"
              />
              <span className="text-[12px] text-[#535963] pl-2 border-l border-[#2e3340] ml-2">
                USD
              </span>
            </div>
          </div>

          {/* calculate button */}
          <button
            onClick={() => {
              doProfitCalc();
              setIsOpen(false);
            }}
            className="w-full min-h-[42px] text-[13px] font-[500] bg-userDashPurple rounded-lg transition-all ease-in duration-200 hover:bg-[#3d34b5]"
          >
            Calculate Return
          </button>

          {/* expected return */}
          <div className="w-full flex justify-between items-center mt-5 pt-5 border-t border-[#1f2535]">
            <p className="text-[13px] text-[#535963]">Expected Return</p>
            <p className="text-[16px] font-[600] text-white">
              {expReturn ? `$${expReturn}` : "—"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Usertrade;
